// We only need to import the modules necessary for initial render
import _ from "lodash";

import CoreLayout from "../layouts/CoreLayout/CoreLayout";
import userService from "../services/user-service";
import AccountManagement from "./AccountManagement";
import AllProductSalesAnalyticsRoute from "./AllProductSalesAnalytics";
import AnalysisRoute from "./Analysis";
import AutoLoginRedirect from "./AutoLoginRedirect";
import B2BOfferModule from "./B2BOfferModule";
import B2BOffersReport from "./B2BOffersReport";
import CampaignRoute from "./Campaign";
import CampaignCreation from "./CampaignCreation";
import CampaignDetails from "./CampaignDetails";
import CampaignDistributionRoute from "./CampaignDistribution";
import CampaignEfficiencyRoute from "./CampaignEfficiency";
import CampaignReports from "./CampaignReports";
import CaptivePortalRoute from "./CaptivePortal";
import CategoryAnalytics from "./CategoryAnalytics";
import CategoryInsightsRoute from "./CategoryInsights";
import Channels from "./Channels";
import ChatbotInterestsRoute from "./ChatbotInterests";
import ClientOffers from "./ClientOffers";
import ClientGiftVouchers from "./ClientGiftVouchers";
import CampaignDelightSettings from "./CampaignDelightSettings";

import {
  BillPurchaseClusteringRoute,
  MultiplePurchaseClusteringRoute,
  SinglePurchaseClusteringRoute,
} from "./ClusteringAnalytics";
import CromaRseReferral from "./CromaRseReferral";
import CrossChannelAnalysis from "./CrossChannelAnalysis";
import CustomerDetails from "./CustomerDetails";
import CustomerInsightsRoute from "./CustomerInsights";
import CustomerInterestsRoute from "./CustomerInterests";
import CustomerOffers, {
  default as CustomerOffersRoute,
} from "./CustomerOffers";
import CustomerPurchaseAnalytics from "./CustomerPurchaseAnalytics";
import DetailedAnalytics from "./DetailedAnalytics";
import EcomOrderManagement from "./EcomOrderManagement";
import FacebookCampaignInsightsRoute from "./FacebookCampaignInsights";
import FieldSalesAssist from "./FieldSalesAssist";
import Flipbook from "./Flipbook";
import ForgotPassword from "./ForgotPassword";
import FormResponseAnalyticsRoute from "./FormResponseAnalytics";
import GeneralSetting from "./GeneralSetting";
import HomeRoute from "./Home";
import JourneyCreate from "./JourneyBuilder/JourneyCreate";
import JourneyListing from "./JourneyBuilder/JourneyListing/JourneyListing";
import KamExpenses from "./KamExpenses";
import Labeling from "./Labeling";
import LeadConversionDaysAnalyticsRoute from "./LeadConversionDaysAnalytics";
import LeadCreationRoute from "./LeadCreation";
import LeadDistributionAnalyticsRoute from "./LeadDistributionAnalytics";
import LeadDropAnalyticsRoute from "./LeadDropAnalytics";
import LeadManagementRoute from "./LeadManagement";
import LeadManagementCategoryWiseReport from "./LeadManagementCategoryWiseReport";
import LiveReports from "./LiveReports";
import LMSConfig from "./LMSDropdownConfig";
import LoginRoute from "./Login";
import Logout from "./Logout";
import LoyaltyAdhocPoints from "./LoyaltyAdhocPoints";
import LoyaltyConfig from "./LoyaltyConfig";
import LoyaltyException from "./LoyaltyException";
import LoyaltyPoints from "./LoyaltyPoints";
import LoyaltyRedeem from "./LoyaltyRedeem";
import LoyaltyRedeemConfiguration from "./LoyaltyRedeemConfiguration";
import LoyaltySummary from "./LoyaltySummary";
import LoyaltyTier from "./LoyaltyTier";
import LoyaltyTierStat from "./LoyaltyTierStat";
import MarketSegmentRoute from "./MarketSegment";
import MembershipPage from "./MembershipPage";
import NpsUserSegmentRoute from "./NetPromotersScoreAnalytics";
import Offer from "./Offer";
import OfferActivation from "./OfferActivation";
import Offerio from "./Offerio";
import OfferMaster from "./OfferMaster";
import OffersAnalytics from "./OffersAnalytics";
import OfferSearch from "./OfferSearch";
import OfferView from "./OfferView";
import OpportunitiesRoute from "./Opportunities";
import OpportunityAnalyticsRoute from "./OpportunityAnalytics";
import OrderCapture from "./OrderCapture";
import OrderCapturePrint from "./OrderCapturePrint";
import OrderDetailsRoute from "./OrderDetails";
import OrderManagementRoute from "./OrderManagement";
import OTPConfiguration from "./OTPConfiguration";
import OverallSummary from "./OverallSummary";
import PlaceHolderRoute from "./Placeholder";
import ProductDemographyRoute from "./ProductDemography";
import ProductManagement from "./ProductManagement";
import ProductSalesAnalyticsRoute from "./ProductSalesAnalytics";
import ProductSalesForecastRoute from "./ProductSalesForecasts";
import ProductWiseSalesAnalytics from "./ProductWiseSalesAnalytics";
import ReferralConfiguration from "./ReferralConfiguration";
import ReportRoute from "./Report";
import CampaignCreate from "./rule-ui-routes/CampaignCreate";
import CampaignList from "./rule-ui-routes/CampaignList";
import CommerceConnect from "./rule-ui-routes/CommerceConnect";
import CreateCohorts from "./rule-ui-routes/CreateCohorts";
import DataUpload from "./rule-ui-routes/DataUpload";
import EmailConfig from "./rule-ui-routes/EmailConfig";
import FormCreate from "./rule-ui-routes/FormCreate";
import FormList from "./rule-ui-routes/FormList";
import LatencyCampaignCreate from "./rule-ui-routes/LatencyCampaignCreate";
import ManageCohorts from "./rule-ui-routes/ManageCohorts";
import MufflerConfig from "./rule-ui-routes/MufflerConfig";
import ParallelUpload from "./rule-ui-routes/ParallelUpload";
import RoleConfig from "./rule-ui-routes/RoleConfig";
// import RoleConfig2 from "./rule-ui-routes/RoleConfig2";
import SmsConfig from "./rule-ui-routes/SmsConfig";
import StoresConfig from "./rule-ui-routes/StoresConfig";
import TenantConfig from "./rule-ui-routes/TenantConfig";
import UploadLogs from "./rule-ui-routes/UploadLogs";
import UserDataDownload from "./rule-ui-routes/UserDataDownload";
import SalesAnalytics from "./SalesAnalytics";
import SalesForecastRoute from "./SalesForecasts";
import SegmentRoute from "./Segment";
import SendCampaignMessagePage from "./SendCampaignMessage";
import SocialMediaReward from "./SocialMediaReward";
import SocialMediaRewardList from "./SocialMediaRewardList";
import StateManagerRoute from "./StateManager";
import StoreManagement from "./StoreManagement";
import PWAConfig from "./PWAConfig";
import UserListing from "./UserListing";
import WalkInInterestsRoute from "./WalkInInterests";
import WalkInInterestsPrintRoute from "./WalkInInterestsPrint";
import InvoiceCreator from "./InvoiceCreator";
import CloneOffer from "./CloneOffer";
// We only need to import the modules necessary for initial render
// import PWAConfig from "./PWAConfig";
/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */
import CreateCustomerGroup from "./CustomerGroup/CreateCustomerGroup";
import EditCustomerGroup from "./CustomerGroup/EditCustomerGroup";
import TransactionWiseReport from "./TransactionWiseReport";
import TransactionWiseReportDownload from "./TransactionWiseReportDownload";
import FraudReport from "./FraudReport";
import MemberReport from "./MemberReport";
import MemberBillReport from "./MemberBillReport";
import TenantReport from "./TenantReport";
import MigrateCustomers from "./MigrateCustomers";
import TenantFieldMapping from "./TenantFieldMapping";
import StaticFileExchange from "./rule-ui-routes/StaticFileExchange";
import StoreHealthGenerate from "./StoreHealthDashboard/GenerateReport";
import StoreHealthView from "./StoreHealthDashboard/ViewReport";
import PwaLoyaltySignUp from "./PwaLoyaltySignUp";
import LiabilitySummaryReport from "./LiabilitySummaryReport";
import CreateEmailTemplate from './rule-ui-routes/CreateEmailTemplate';
import ListEmailTemplate from './rule-ui-routes/ListEmailTemplate';
import OverallLeadReport from "./LeadReport/OverallLeadReport";
import StoreCategoryReport from "./LeadReport/StoreCategoryReport/StoreCategoryReport";

export const createRoutes = (store, keycloak) => ({
  path: "/",
  component: CoreLayout,
  indexRoute: {
    onEnter: (nextState, replace, callback) => {
      let keycloakToken = keycloak !== undefined ? keycloak.token : "";
      return userService
        .getCurrentUser(keycloakToken)
        .then((user) => {
          let isCustomerAssociate = userService.isCustomerAssociate(user);
          let userRole = userService.getUserRole(user);
          let redirectRoute = _.get(
            _.get(userRole, "generalConfig", {}),
            "dashboardPrimaryPage",
            ""
          );
          if (!_.isEmpty(redirectRoute)) {
            let redirection = userService.routeStringTemplate(redirectRoute);
            replace(redirection);
          } else {
            if (isCustomerAssociate) {
              replace("/customer-details");
            } else {
              let isDemoUser = _.endsWith(_.get(user, "tenant.esKey"), "_demo");
              replace(
                isDemoUser
                  ? "/purchases-clustering-analytics"
                  : "/overall-summary"
              );
            }
          }
          callback();
        })
        .catch(() => callback(replace("/login")));
    },
  },
  childRoutes: [
    LoginRoute(store),
    CampaignRoute(store),
    HomeRoute(store),
    ReportRoute(store),
    PlaceHolderRoute(store),
    SegmentRoute(store),
    AnalysisRoute(store),
    CampaignDistributionRoute(store),
    CampaignEfficiencyRoute(store),
    MarketSegmentRoute(store),
    FacebookCampaignInsightsRoute(store),
    ProductDemographyRoute(store),
    CustomerInterestsRoute(store),
    CustomerInsightsRoute(store),
    WalkInInterestsRoute(store),
    ChatbotInterestsRoute(store),
    LeadManagementRoute(store),
    LeadCreationRoute(store),
    LeadConversionDaysAnalyticsRoute(store),
    NpsUserSegmentRoute(store),
    LeadDistributionAnalyticsRoute(store),
    LeadDropAnalyticsRoute(store),
    OrderManagementRoute(store),
    StateManagerRoute(store),
    WalkInInterestsPrintRoute(store),
    ProductSalesAnalyticsRoute(store),
    CustomerPurchaseAnalytics(store),
    AllProductSalesAnalyticsRoute(store),
    FormResponseAnalyticsRoute(store),
    OrderCapturePrint(store),
    OrderCapture(store),
    OrderDetailsRoute(store),
    SalesAnalytics(store),
    DetailedAnalytics(store),
    AutoLoginRedirect(store),
    OpportunityAnalyticsRoute(store),
    CategoryInsightsRoute(store),
    SalesForecastRoute(store),
    ProductSalesForecastRoute(store),
    CaptivePortalRoute(store),
    OffersAnalytics(store),

    OfferMaster(store),
    OpportunitiesRoute(store),
    ProductWiseSalesAnalytics(store),
    SinglePurchaseClusteringRoute(store),
    MultiplePurchaseClusteringRoute(store),
    BillPurchaseClusteringRoute(store),
    CategoryAnalytics(store),
    CustomerDetails(store),
    OverallSummary(store),
    Offer(store),
    OfferView(store),
    Flipbook(store),
    CloneOffer(store),
    SocialMediaReward(store),
    SocialMediaRewardList(store),
    CustomerOffersRoute(store),
    CampaignCreation(store),
    LoyaltyTier(store),
    LoyaltyAdhocPoints(store),
    LoyaltySummary(store),
    LoyaltyTierStat(store),
    LeadManagementCategoryWiseReport(store),
    CrossChannelAnalysis(store),
    SendCampaignMessagePage(store),
    CromaRseReferral(store),
    MembershipPage(store),
    EcomOrderManagement(store),
    ForgotPassword(store),
    B2BOfferModule(store),
    B2BOffersReport(store),
    KamExpenses(store),
    Labeling(store),
    JourneyCreate(store),
    JourneyListing(store),
    ManageCohorts(store),
    CreateCohorts(store),
    StaticFileExchange(store),
    CampaignList(store),
    CampaignCreate(store),
    CommerceConnect(store),
    LatencyCampaignCreate(store),
    FormCreate(store),
    FormList(store),
    RoleConfig(store),
    // RoleConfig2(store),
    EmailConfig(store),
    TenantConfig(store),
    SmsConfig(store),
    MufflerConfig(store),
    StoresConfig(store),
    DataUpload(store),
    UploadLogs(store),
    ParallelUpload(store),
    UserDataDownload(store),
    AccountManagement(store, keycloak),
    FieldSalesAssist(store),
    UserListing(store),
    Logout(store, keycloak),
    LMSConfig(store),
    LoyaltyRedeem(store),
    OfferActivation(store),
    LoyaltyConfig(store),
    LoyaltyException(store),
    // PWAConfig(store),
    GeneralSetting(store),
    ClientOffers(store),
    ClientGiftVouchers(store),
    Channels(store),
    LoyaltyRedeemConfiguration(store),
    ReferralConfiguration(store),
    LoyaltyPoints(store),
    Offerio(store),
    StoreManagement(store),
    PWAConfig(store),
    PwaLoyaltySignUp(store),
    OfferSearch(store),
    ProductManagement(store),
    LiveReports(store),
    OTPConfiguration(store),
    InvoiceCreator(store),
    CreateCustomerGroup(store),
    EditCustomerGroup(store),
    TransactionWiseReport(store),
    CampaignDetails(store),
    CampaignReports(store),
    TransactionWiseReportDownload(store),
    FraudReport(store),
    MemberReport(store),
    MemberBillReport(store),
    TenantReport(store),
    MigrateCustomers(store),
    TenantFieldMapping(store),
    StoreHealthGenerate(store),
    StoreHealthView(store),
    LiabilitySummaryReport(store),
    CampaignDelightSettings(store),
    CreateEmailTemplate(store),
    ListEmailTemplate(store),
    OverallLeadReport(store),
    StoreCategoryReport(store)
  ],
  keycloak: keycloak,
});

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js